export const storeObject = <T>(key: string, content: T) => {
  if ("localStorage" in window) {
    window.localStorage.setItem(key, JSON.stringify(content));
  }
};

export const getObject = <T>(key: string): T | null => {
  if (!("localStorage" in window)) {
    return null;
  }

  const item = window.localStorage.getItem(key);

  if (!item) {
    return null;
  }

  return JSON.parse(item);
};

export const remove = (key: string) => {
  if ("localStorage" in window) {
    window.localStorage.removeItem(key);
  }
};
